import { render, staticRenderFns } from "./manage-cards.vue?vue&type=template&id=dc2553c0"
import script from "./manage-cards.vue?vue&type=script&lang=js"
export * from "./manage-cards.vue?vue&type=script&lang=js"
import style0 from "./manage-cards.vue?vue&type=style&index=0&id=dc2553c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports